module.exports = __webpack_public_path__ + "static/media/Photos_top_coche_amigos.1a0fe509.png";